import { render, staticRenderFns } from "./StepThreeSMS.vue?vue&type=template&id=1890bee8&lang=pug"
import script from "./StepThreeSMS.vue?vue&type=script&lang=ts"
export * from "./StepThreeSMS.vue?vue&type=script&lang=ts"
import style0 from "./StepThreeSMS.vue?vue&type=style&index=0&id=1890bee8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports